import { NgModule } from '@angular/core';

import { SharedModule } from '../shared.module';
import { JobDetailsComponent } from 'src/app/components/job/jobdetails.component';
import { AdvertService } from 'src/app/services/advert.service';
import { AccountService } from 'src/app/services/account.service';
import { JobsRoutingModule } from './job-routing.module';

@NgModule({
    imports: [
        SharedModule,
        JobsRoutingModule
    ],
    declarations: [
        JobDetailsComponent
    ],
    providers: [
        AdvertService,
        AccountService
    ]
})
export class JobsModule { }
